module.exports = __webpack_public_path__ + "static/media/hybriq.f22b2655.svg";